import React, { useState, useEffect, PropTypes } from "react"
import $ from "jquery";
import qs from "qs"
import { Button, Form, Container, Row, Col, Fade } from "react-bootstrap";
import algoliasearch from "algoliasearch/lite"
import Modal from "react-bootstrap/Modal"
import {
    connectStats,
    SortBy,
    connectInfiniteHits,
    InstantSearch,
    RefinementList,
    connectSearchBox,
    connectMenu,
    connectRange,
    Configure,
    ToggleRefinement,
    connectSortBy,
    connectAutoComplete,
    ClearRefinements,
    connectToggleRefinement
} from "react-instantsearch-dom"
import {
  GoogleMapsLoader,
  GeoSearch,
  CustomMarker
} from 'react-instantsearch-dom-maps'
import Cookies from 'universal-cookie'
import { navigate } from "@reach/router"
import { Link } from "gatsby"
import Select from "react-select"
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../components/property-search/seoResultsMap"
import { parseSearchUrl, propertyH1, propertyDesc, savedSearchParams } from "../components/property-search/utilsMap";
import {resiSalesPropertyType, resiLettingsPropertyType, priceminRangeResiSale, pricemaxRangeResiSale, priceminRangeResiRent, pricemaxRangeResiRent, bedroomsRange} from "../components/common/propertyUtils";
import Layout from "../components/layout"
import Seo from "../components/seo";
import PropertySearchBar from '../components/property-search-bar/property-search-bar';
import NoImage from "../images/no-image.png"

// 
const mycookies = new Cookies();
const updateAfter = 500
const DEBOUNCE_TIME = 500;

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""

var includeSoldLet = false;

const searchClient = algoliasearch(
   process.env.GATSBY_ALGOLIA_APP_ID,
   process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)
const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`
// 

// Searchbox
const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
    return (
        <div className="filter-search-input-box">
            <div className="dropdown">
                <i className="icon-location-input"></i>
                <Form.Control type="search" placeholder="Street, area or postcode" id="formBasicEmail" 
                  onChange={event => refine(event.currentTarget.value.replace(/ /g, "-").toLowerCase())}
                  value={currentRefinement.replace(/-/g, ' ')}
                />
            </div>
        </div>
    )
})
// Searchbox

// Property type
const buildingSelectbox = ({ items, currentRefinement, refine, department, type }) => {
    var propertyListDropdown = resiSalesPropertyType;
    if (department === "residential" && type === "lettings") {
      propertyListDropdown = resiLettingsPropertyType;
    }

    return (
      <Select
        name="building"
        options={propertyListDropdown}
        // value={{ value: 0, label: "All" }}
        placeholder="Property Type"
        onChange={(e) => { refine(e.value, e.label) }}
        isSearchable={false}
      />
    )
}
  
const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type

// Property Bedrooms
const bedroomSelectBox = ({
    currentRefinement,
    min,
    max,
    precision,
    refine,
  }) => {
  
    let bedroomvalselect = ""
    if (currentRefinement.max !== undefined) {
      // bedroomvalselect = 0
      bedroomvalselect = currentRefinement.max
    } else if (currentRefinement.min !== undefined) {
      bedroomvalselect = currentRefinement.min
    }
  
    return (
      <Select
        name="bedroom"
        options={bedroomsRange}
        // value={{ value: "", label: "Any" }}
        placeholder="Bedrooms"
        onChange={(e) => {
          if (e.value === "") {
            refine(e.value)
          } else if (e.value === "0") {
            refine({
              max: e.value,
            })
          } else {
            refine({
              min: e.value,
            })
          }
        }}
        isSearchable={false}
      />
    )
}
  
const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// Property Bedrooms 

// Min Price
const minpriceSelectbox = ({
    currentRefinement,
    min,
    max,
    precision,
    refine,
    type
}) => {
    var minPriceRange = priceminRangeResiSale;
    if (type === "lettings") {
      minPriceRange = priceminRangeResiRent;
    }
    if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
      minPriceRange = minPriceRange.filter((x) => parseInt(x.value) < parseInt(currentRefinement.max))
    }
  
    minpriceval = currentRefinement.min
    return (
      <Select
        name="minprice"
        options={minPriceRange}
        isSearchable={false}
        placeholder="Min Price"
        onChange={(e) => {
          minpriceval = e.value
          if (e.value === "0") {
            if (maxpriceval !== "0") {
              refine({
                max: maxpriceval,
              })
            } else refine(e.value, e.label)
          } else {
            refine({
              min: e.value,
              max: maxpriceval,
            })
          }
        }}
      />
    )
}
  
const CustomminpriceSelectbox = connectRange(minpriceSelectbox)
// Min Price

// Max Price
const maxpriceSelectbox = ({
    currentRefinement,
    min,
    max,
    precision,
    refine,
    type
}) => {
    var maxPriceRange = pricemaxRangeResiSale;
    if (type === "lettings") {
      maxPriceRange = pricemaxRangeResiRent;
    }
    let maxpricedisable = ''
    if (currentRefinement.min !== undefined) {
      maxPriceRange = maxPriceRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
    }
    if (currentRefinement.min == "400000") {
      maxpricedisable = 'disabled'
    }
    maxpriceval = currentRefinement.max
    return (
      <Select
        name="maxprice"
        options={maxPriceRange}
        defaultValue={{ value: "0", label: "Max Price" }}
        placeholder="Max Price"
        classNamePrefix={"select-opt"}
        isSearchable={false}
        onChange={(e) => {
          maxpriceval = e.value
          if (e.value === "0") {
            if (minpriceval) {
              refine({
                min: minpriceval,
              })
            } else refine(e.value, e.label)
          } else {
            refine({
              min: minpriceval,
              max: e.value,
            })
          }
        }}
      />
    )
}
  
const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox)
// Max Price

// Sort by
const sortbyStyle = {
    control: base => ({
      ...base,
      boxShadow: "none",
      border: "none",
    }),
}

const CustomSortBy = ({ items, refine, currentRefinement }) => (
    <div className="property-filter__action sort">
        <span className="property-filter__label">Sort: </span>
        <Select
            isSearchable={false}
            styles={sortbyStyle}
            options={items}
            classNamePrefix={"custom-select"}
            className={"custom-select"}
            defaultValue={currentRefinement || ''}
            onChange={(e) => { refine(e.value, e.label) }}
            placeholder={
                <div className="custom-select__placeholder"> {"Most Recent"}</div>
            }
        />
    </div>
);
  
const CustomSortByFilter = connectSortBy(CustomSortBy);
// Sort by

// Include sold and let
const ToggletttRefinement = ({
    currentRefinement,
    label,
    count,
    refine,
    createURL,
  }) => {
    return (
      <a
        href={'#'}
        onClick={event => {
          event.preventDefault();
          includeSoldLet = !includeSoldLet;
          refine(!currentRefinement);
        }}
      >
        <div className="property-filter__action">
            <input type="checkbox" id="sold" name="sold" checked={includeSoldLet ? "checked" : ""} />
            <label htmlFor="sold" className="property-filter__label">{label}</label>
        </div>
      </a>
    )
}
    
const CustomToggleRefinement = connectToggleRefinement(ToggletttRefinement);
// Include sold and let

// No Results
const NoStats = ({ processingTimeMS, nbHits, location, status, department, OpenMember}) => {
  return (
    <>
      {nbHits === 0 &&
        <>
          <div className="shell">
            <Row className="property-filter__row">
              <Col lg={12} className="no-properties-text mb-5">
                <h2 className="mb-0">Unfortunately, we do not currently have any properties that match your search criteria.</h2>
              </Col>
            </Row>
            {/* <NoResultList uriStr={location} status={status} department={department} OpenMember={OpenMember}/> */}
          </div>
        </>
      }
    </>
  )
}

const CustomNoStats = connectStats(NoStats)
// No Results

// Results count
const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

const CustomStats = connectStats(Stats)
// Results count

// Map results
const MapResults = (() => {
    return (
      <>
        <div id="map" className="map">
          <GoogleMapsLoader apiKey={process.env.GATSBY_MAPS_API_KEY}>
            {google => <MapResultswrapper google={google} />}
          </GoogleMapsLoader>
        </div>
      </>
    )
  })
  
  var InfoWindow;
  var onClickMarker;
  var html;
  
  const MapResultswrapper = ( (props) => {
    InfoWindow = new props.google.maps.InfoWindow();
  
    onClickMarker = ({ hit, marker }) => {
  
      if (InfoWindow.getMap()) {
        InfoWindow.close();
      }
  
      // property details url structure
      let uriStr = "";
  
      if(hit.searchType === "sales" && hit.department === 'residential' ) {
        uriStr = 'property-for-sale/'
      } else if (hit.searchType === "lettings" && hit.department === 'residential') {
        uriStr = `property-to-rent/`
      }
      // property details url structure
  
      // available days
      let currFullDate = new Date();
      let currYear = currFullDate.getFullYear();
      let currMonth = currFullDate.getMonth() +1;
      let currDate = currFullDate.getDate();
      let currDateCal = currYear+"-"+currMonth+"-"+currDate;
      let propertyDate = hit.AvailableFrom;
      let availableFrom = "";
      let date1 = new Date(propertyDate).getTime();
      let date2 = new Date(currDateCal).getTime();
  
      if(date1 > date2) {
        var timeDiff = Math.abs(date1 -date2);
        // days difference
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        availableFrom = diffDays;
      } else { }
      // available days
  
      // display address
      var propertyAddressFinal = ""
  
      if (hit.display_address === undefined ) {
        propertyAddressFinal = hit.display_address;
      } else {
        var propertyAddress = hit.display_address;
        var propertySplit = propertyAddress.split(',');
  
        for(var i = 0; i < propertySplit.length; i++) {
          // Trim the excess whitespace.
          propertySplit[i] = propertySplit[i].replace(/^\s*/, "").replace(/\s*$/, "");
          // Add additional code here, such as:
          propertyAddressFinal = propertySplit[0];
        }
      }
  
      html = '<a href="/'+uriStr+hit.slug+'-'+hit.objectID+'"><div class="result-cards"><div class="contact-card"><figure><img src="'+(hit.images1 && (hit.images1.length > 0) ? hit.images1[0]['640x422'] : NoImage)+'" /><span class="card-tag"></span></figure><div class="info"><h2>£'+hit.price.toLocaleString()+''+(hit.searchType === "lettings" ? " PCM" : "")+'</h2><h4 class="card-title">'+hit.display_address+'</h4><div class="d-flex justify-content-start"><div class="property-map-icon d-flex align-items-center"><i class="icon-bed"></i><span>'+hit.bedroom+''+(hit.bedroom > 1 ? " Bedrooms" : " Bedroom")+'</span></div><div class="property-map-icon d-flex align-items-center"><i class="icon-bathroom"></i><span>'+hit.bathroom+''+(hit.bathroom > 1 ? " Baths" : " Bath")+'</span></div></div></div></div></div></a>';
  
      InfoWindow.setContent(html);
  
      InfoWindow.open(marker.getMap(), marker);
    };
  
    return (
      <>
        <GeoSearch 
          google={props.google}
          enableRefineOnMapMove={false}
          initialZoom={10}
          // initialPosition={{
          //   lat: 25.426,
          //   lng: 51.50835,
          // }}
        >
            {({ hits }) => (
                <div>
                    {hits.map(hit => (
                        <>
                          <CustomMarker
                            anchor={{ x: 0, y: -5 }}
                            key={hit.objectID}
                            position={hit._geoloc}
                            hit={hit}
                            className={"icon-property_map_marker map-marker-"+ hit.objectID}
                            onClick={({ marker }) => {
                              onClickMarker({ hit, marker, });
                            }}
                          />
                        </>
                    ))}
                </div>
            )}
        </GeoSearch>
      </>
    )
  })
  // Map results

// Create URL
export const createURL = (props, state, location) => {
    let myarea = state.menu
  
    const isDefaultRoute =
      !state.query &&
      !state.SortBy &&
      state.page === 1 &&
      state.menu &&
      state.range &&
      !state.range.price &&
      !state.range.bedroom
  
    if (isDefaultRoute) {
      return ""
    }
  
    var areaPath = "in-sittingbourne/"
    var bedroomPath = ""
    var pricePath = ""
    var pagePath = ""
    var propertypath = ""
    var sortPath = ""
  
    if (state.query) {
      if (state.query) {
        areaPath = "in-" + encodeURIComponent(decodeURIComponent(state.query)) + "/"
      }
    }
  
    const queryParameters = {}
  
    // Property path
    if (state.menu) {
      if (myarea["building"]) {
        propertypath = "type-" + myarea["building"] + "/"
      }
    }
    // Property path
  
    // Bedrooms & Price range path
    if (state.range) {
      // Bedrooms
      if (state.range.hasOwnProperty('bedroom') && parseInt(state.range.bedroom.max) == 0) {
        bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
      }
      if (state.range.bedroom) {
        if (state.range.bedroom.min) {
          bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
        }
      }
  
      // Price
      if (state.range.price) {
        if (state.range.price.min && state.range.price.max) {
          pricePath = "between-" + state.range.price.min + "-and-" + state.range.price.max + '/' //queryParameters.price_min = state.range.price.min;
        } else if (state.range.price.max) {
          pricePath = "under-" + state.range.price.max + '/' //queryParameters.price_max = state.range.price.max;
        } else if (state.range.price.min) {
          pricePath = "over-" + state.range.price.min + '/' //queryParameters.price_max = state.range.price.max;
        }
      }
    }
    // Bedrooms & Price range path
  
    // Sort path
    if (state.sortBy) {
      if (state.sortBy === index_name + "_price_asc") {
        sortPath = "sortby-price-asc/";
      }
      if (state.sortBy === index_name + "_price_desc") {
        sortPath = "sortby-price-desc/";
      }
      if (state.sortBy === index_name + "_most_recent") {
        sortPath = "sortby-most-recent/";
      }
    }
    // Sort path
  
    // Page path
    if (state.page && state.page !== 1) {
      pagePath = `page-${state.page}/`
    }
    // Page path
  
    const queryString = qs.stringify(queryParameters, {
      addQueryPrefix: true,
      arrayFormat: "repeat",
    })
  
    let myUrl = `${areaPath}${propertypath}${bedroomPath}${pricePath}${queryString}${pagePath}${sortPath}`
  
    if ("/" === myUrl.substr(myUrl.length - 1))
      myUrl = myUrl.substr(0, myUrl.length - 1)
  
    return `${location}${myUrl}`
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
    searchState ? `${createURL(props, searchState, location)}` : ""
  
const urlToSearchState = location => {
    if (location) {
      var query = ""
      let pathUri_main = ''
  
      let a1 = location.pathname.indexOf("/property-map/for-sale") > -1
      let a2 = location.pathname.indexOf("/property-map/to-rent") > -1

      if (a1 == true) {
        pathUri_main = location.pathname.split("/property-map/for-sale")
      } else if (a2 == true) {
        pathUri_main = location.pathname.split("/property-map/to-rent")
      } else {
        pathUri_main = location.pathname.split(location)
      }
  
      var areaVal = ""
      var bedVal = 10
      var minpriceVal = ""
      var maxpriceVal = ""
      var pageVal = ""
      var propertyval = ""
      var sortVal = ""
      var sortVal_filt = ""
  
      if (pathUri_main[1]) {
        // following could be regexp
        let pathUri = pathUri_main[1].split("/")
  
        //lets loop
        for (let vi = 1; vi <= pathUri.length; vi++) {
          // check for area
          if (typeof pathUri[vi] === "undefined") {
            continue
          }
  
          // Property type
          if (pathUri[vi].indexOf("type-") >= 0) {
            propertyval = pathUri[vi].replace("type-", "")
          }
  
          // Area
          if (pathUri[vi].indexOf("in-") >= 0) {
            areaVal = pathUri[vi].replace("in-", "")
          }
  
          // Price
          if (
            pathUri[vi].indexOf("between-") >= 0 ||
            pathUri[vi].indexOf("over-") >= 0 ||
            pathUri[vi].indexOf("under-") >= 0
          ) {
            let priceFilt1 = pathUri[vi].split("over-")
            if (priceFilt1[1]) {
              minpriceVal = priceFilt1[1]
            }
            let priceFilt2 = pathUri[vi].split("under-")
            if (priceFilt2[1]) {
              maxpriceVal = priceFilt2[1]
            }
            let priceFilt3 = pathUri[vi].split("between-")
            if (priceFilt3[1]) {
              let priceFilt4 = priceFilt3[1].split("-and-")
              minpriceVal = priceFilt4[0]
              maxpriceVal = priceFilt4[1]
            }
          }
  
          // Bedrooms
          if (pathUri[vi].indexOf("-and-more-") >= 0) {
            bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
            // sortVal = index_name+"_bedrooms"
          }
  
          if (pathUri[vi].indexOf("studio") >= 0) {
            // its studio bedroom
            bedVal = 0
          }
  
          // Sort by
          if (pathUri[vi].indexOf("sortby-") >= 0) {
            sortVal_filt = pathUri[vi].replace("sortby-", "")
  
            if (sortVal_filt === "price-asc") {
              sortVal = index_name + "_price_asc"
            }
  
            if (sortVal_filt === "price-desc") {
              sortVal = index_name + "_price_desc"
            }

            if (sortVal_filt === "most-recent") {
                sortVal = index_name + "_most_recent"
            }
          }
  
          // Page
          if (pathUri[vi].indexOf("page") >= 0) {
            pageVal = pathUri[vi].replace("page-", "")
          }
        }
      }
    }
  
    // Property type
    if (propertyval) {
      query += `&menu[building]=` + propertyval
    }
  
    // Area
    if (areaVal) {
      areaVal = areaVal.toLowerCase();
      if(areaVal.length < 4) {
        areaVal = '"'+areaVal+'"'
      }
      if (areaVal == "sittingbourne") query += `&query=`
      else query += `&query=` + areaVal
    }
  
    // Price
    if (minpriceVal) {
      query += `&range[price][min]=` + minpriceVal
    }
  
    if (maxpriceVal) {
      query += `&range[price][max]=` + maxpriceVal
    }
  
    // Bedrooms
    if (bedVal == 0) {
      query += `&range[bedroom][min]=` + 0
      query += `&range[bedroom][max]=` + 0
    } else if (bedVal < 10) {
      query += `&range[bedroom][min]=` + bedVal
    }
  
    // Page
    if (pageVal) {
      query += `&page=${pageVal}`
    }
  
    // Sort by
    if (sortVal) {
      query += `&sortBy=` + sortVal
    }

    return qs.parse(query)
}
// URL to searchstate

class SearchResultsMapTemplate extends React.Component {
    
    constructor(props) {
        super(props);
    }

    // 
    state = {
        searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
        userObjects: [],
        mapview: false,
        isOpen: false,
        popupType: "",
        membDet:"",
        include_sold_let: false,
        include_sold_let_value: ""
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            this.setState({ searchState: urlToSearchState(this.props.location) })
        }
    }

    onSearchStateChange = searchState => {
        clearTimeout(this.debouncedSetState)
        this.debouncedSetState = setTimeout(() => {
            navigate(searchStateToUrl(this.props, searchState, this.props.locationname), searchState)
        }, updateAfter)
        this.setState({ searchState })
    }
    // 

    // Map view
    gridView = (e) => {
        navigate(this.props.location.pathname.replace("property-map", "property"))
    }
    // Map View

    includeSoldClick = (val) => {
      this.setState({
        include_sold_let: !this.state.include_sold_let,
        include_sold_let_value: val
      });
    }

    render () {

        // Capitalize
        const capitalize = (s) => {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
        // Capitalize

        const searchParams = parseSearchUrl(this.props.ptype, this.props.fullpathname, this.props.pcategorytype);

        const h1 = propertyH1(searchParams, this.props.pcategorytype);

        const h1desc = propertyDesc(searchParams);
        
        const areaName = searchParams.areas;
    
        const pType = searchParams.pType;

        let propertyType = "";
        if (searchParams.type == "") {
          propertyType = "properties "
        } else {
          propertyType = searchParams.type
        }
    
        const actionStr = ACTION_TYPES[pType];

        var description = `Explore our latest collection of ${capitalize(propertyType)} ${actionStr} ${searchParams.areas}. Contact LambornHill estate agents in ${searchParams.areas} to find the right property for you.`

        const isPageLoadBg = (typeof this.props.fullpathname === "undefined");
        var split_sort_by = this.props.location.pathname.split('sortby-');
        var sort_by = split_sort_by.length > 1 ? split_sort_by[1] : '';
        var replaceH1 = h1.replace(/-/g, ' ');
        //replaceH1 = replaceH1.replace("Essex", "Essex and Kent");
        var replaceh1SEC = h1desc.replace(/-/g, ' ');
        //replaceh1SEC = replaceh1SEC.replace("Essex", "Essex and Kent");
        var areaReplace = capitalize(areaName).replace("%20"," ")
        //areaReplace = areaReplace.replace("Essex", "Essex and Kent");


        let mystatus = ''
        if(this.state.include_sold_let === true){
          mystatus = '(status:"'+(this.props.pstatustype)+'" OR status:"'+(this.state.include_sold_let_value)+'")'
        } else{
          if(this.props.pstatustype){
            if(Array.isArray(this.props.pstatustype)){
                mystatus = '(status:"'+(this.props.pstatustype).join('" OR status:"')+'")'
            } else {
                mystatus = '(status:"'+(this.props.pstatustype)+'")'
            }
          }
        }

        return (
            <Layout tag={"mapView"} popularsearch={this.props.psearch}>
                {!isPageLoadBg &&
                  <SeoResults title={h1} searchParams={searchParams} description={description} location={this.props.fullpathname} pcategorytype={this.props.pcategorytype} />
                }

                <InstantSearch
                    indexName={index_name}
                    searchClient={searchClient}
                    searchState={this.state.searchState}
                    onSearchStateChange={this.onSearchStateChange}
                    createURL={createURL}
                    routing="true"
                >
                    <div className="d-none">
                        {/* <RefinementList
                            attribute="searchType"
                            defaultRefinement={[this.props.ptype]}
                        />
                        <RefinementList
                            attribute="department"
                            defaultRefinement={[this.props.pcategorytype]}
                        />
                        <RefinementList
                            attribute="status"
                            defaultRefinement={[this.props.pstatustype]}
                        />
                        <RefinementList
                            attribute="publish"
                            defaultRefinement={[true]}
                        /> */}
                    </div>

                    <Configure 
                        hitsPerPage={1000}
                        filters={`publish:true AND searchType:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus}`}
                    />

                    {/* <Seo title="Property Search" /> */}
    
                    <PropertySearchBar 
                        type={this.props.ptype} 
                        department={this.props.pcategorytype}
                        propertyMap={"map"}
                        sort_by={sort_by}
                    />

                    <div className="d-none">
                        <SearchBox />
                        <CustomminpriceSelectbox attribute="price" type={this.props.ptype} />
                        <CustommaxpriceSelectbox attribute="price" type={this.props.ptype} />
                        <CustombuildingSelectbox attribute="building" type={this.props.ptype} department={this.props.pcategorytype} />
                        <CustombedroomSelectbox attribute="bedroom" />
                    </div>

                    <div className="property-filter" data-aos="fade-up">
                        <div className="shell">
                            <div className="property-filter__row intro-head">
                              <div className="property-filter__text">
                                <h1>{h1.replace(/-/g, ' ')}</h1>
                                <p className="result-intro">Discover a wide range of {replaceh1SEC} with LambornHill estate agents. To filter these results, use our filter above, or for more information about {pType} property in {areaReplace}, please contact our estate agents in Sittingbourne.</p>
                              </div>                            
                            </div>
                            <Row className="property-filter__row">
                                <Col className="property-filter__text">
                                    <p><CustomStats /> results found</p>
                                </Col>
                                <Col className="property-filter__actions">
                                    <div className="property-filter__action location">
                                        <i className="icon-list-view"></i>
                                        <a href="javascript:void(0)" onClick={this.gridView} className="property-filter__label">View in a List</a>
                                    </div>
    
                                    {
                                        this.props.ptype === "sales" ?
                                          // <CustomToggleRefinement
                                          //     attribute="status"
                                          //     label="Include Sold"
                                          //     value={['Sold Subject To Contract']}
                                          //     defaultRefinement={includeSoldLet}
                                          // />
                                          <div className="property-filter__action">
                                              <input type="checkbox" id="sold" name="sold" onChange={() =>this.includeSoldClick('Sold Subject To Contract')} />
                                              <label htmlFor="sold" className="property-filter__label">Include Sold</label>
                                          </div>
                                        :
                                          // <CustomToggleRefinement
                                          //     attribute="status"
                                          //     label="Include Let"
                                          //     value={['Let Agreed']}
                                          //     defaultRefinement={includeSoldLet}
                                          // />
                                          <div className="property-filter__action">
                                              <input type="checkbox" id="sold" name="sold" onChange={() =>this.includeSoldClick('Let Agreed')} />
                                              <label htmlFor="sold" className="property-filter__label">Include Let</label>
                                          </div>
                                    }
    
                                    {/* <CustomSortByFilter
                                        defaultRefinement={index_name}
                                        className="search-sory-by"
                                        items={[
                                            { value: index_name+"_most_recent", label: "Most Recent" },
                                            { value: index_name+"_price_desc", label: "Highest Price" },                                        
                                        ]}
                                    /> */}
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="mapresults">
                        <MapResults />
                    </div>
                </InstantSearch>
            </Layout>
        )
    }
}

export default SearchResultsMapTemplate